import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()
  const [api] = useState(() => ({
    ok: translate({ id: 'changelogModal.ok' }),
    title: translate({ id: 'changelogModal.title' }),
  }))

  return api
}
